export default "__VITE_ASSET__BMvSeVDj__"